<template>
  <div id="service-filter">
    <div id="related">
      <van-tabs v-model="params.related">
        <van-tab title="与我相关" name="true"/>
        <van-tab title="全部事项" name="false"/>
      </van-tabs>
    </div>
    <div class="white-bg">
      <div id="depts" class="filter-item-box" v-if="!serviceHallCategoryModel || serviceHallListModel">
        <div class="title">所属部门</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index) in serviceDepts"
               :key="'dept-'+index"
               @click="selectDepts(item.deptId)"
               :class="params.publisher===item.deptId?'current':''">{{ item.deptName }}
          </div>
        </div>
      </div>
      <div id="objs" class="filter-item-box">
        <div class="title">服务对象</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index) in serviceObjects"
               :key="'obj-'+index"
               @click="selectObjs(item.id)"
               :class="params.target===item.id?'current':''">{{ item.objectName }}
          </div>
        </div>
      </div>
      <div id="types" class="filter-item-box" v-if="serviceHallCategoryModel || serviceHallListModel">
        <div class="title">事项性质</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index)  in serviceTypes"
               :key="'type-'+index"
               @click="selectTypes(item.id)"
               :class="params.type===item.id?'current':''">
            {{ item.typeName }}
          </div>
        </div>
      </div>
      <div id="ways" class="filter-item-box">
        <div class="title">办理模式</div>
        <div class="tags">
          <div class="tag"
               v-for="(item, index) in serviceWays"
               :key="'way-'+index" @click="selectWays(item.id)"
               :class="params.handleWay===item.id?'current':''">{{ item.transactWayName }}
          </div>
        </div>
      </div>
      <div class="btn-control">
        <button class="btn-reset" @click="reset">重置</button>
        <button class="btn-confirm" @click="confirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import {Tabs, Tab} from 'vant'
import store from "@/store";
import {mapState} from "vuex";
import {getThemeParams} from "@/utils/theme";

export default {
  name: "serviceFilter",
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['serviceObjects', 'serviceWays', 'serviceTypes', 'serviceDepts', 'serviceParams']),
    params() {
      return this.serviceParams;
    },
    serviceHallCategoryModel(){
      return getThemeParams('hall_default_category') === "0";//0为部门 1为事项
    },
    serviceHallListModel(){
      return getThemeParams('hallListModel') === "0";//0为列表模式 1为名片模式
    }
  },
  beforeCreate() {
    store.commit('updateGlobalBg',"#FFFFFF");
  },
  created() {
    if (this.serviceObjects.length <= 0) {
      this.$router.push('/homeTab/serviceHall');
    }
  },
  beforeDestroy() {
    store.commit('updateGlobalBg',"#F7F7F7");
  },
  methods: {
    selectTypes(e) {
      this.params.type = e === 'all' ? undefined : e;
    },
    selectObjs(e) {
      this.params.target = e === 'all' ? undefined : e;
    },
    selectWays(e) {
      this.params.handleWay = e === 'all' ? undefined : e;
    },
    selectDepts(e) {
      this.params.publisher = e === 'all' ? undefined : e;
    },
    reset() {
      this.params = {
        target: undefined,//服务对象
        publisher: undefined,//所属部门
        handleWay: undefined,//办理途径
        type: undefined,//事项类型
        related: undefined,
      };
      store.commit("updateServiceParams", Object.assign(this.serviceParams,this.params));
    },
    confirm() {
      store.commit("updateServiceParams", this.params);
      this.$router.push('/homeTab/serviceHall');
    },
    getThemeParams
  }

}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
#service-filter{
  height:100%;
}
#related{
  padding-bottom: 18px;
  background-color: #f7f7f7;
}
.van-tab--active{
  color:var(--main-color) !important;
  border:1px solid red;
}
.van-tabs{
  .van-tabs__line {
    background-color:var(--main-color) !important;
  }
}

.white-bg {
  margin-top: 12px;
  background: #ffffff;
}

.filter-item-box {
  margin-top: 20px;
  padding:0 15px;
  &:first-child{
    margin-top:15px;
  }
}

.title {
  color: #333;
  margin-bottom: 15px;
  @extend .font16;
}

.tags {
  .tag {
    display: inline-flex;
    padding: 10px 11px;
    background-color: #F7F7F7;
    color: #999999;
    border-radius: 17px;
    justify-content:space-around;
    margin:0 4px 8px;
    @extend .font14;
    &.current {
      background-color: var(--main-color);
      color: #ffffff;
    }
  }
}

.btn-control {
  width:100%;
  position:fixed;
  bottom:0;
  button {
    width:50%;
    height:40px;
    color: #fff;
    border:none;
    @extend .font14;
    &.btn-reset{
      background-color: #E6E6E6;
      color:#666666;
    }
    &.btn-confirm{
      background-color: var(--main-color);
    }
  }
}

</style>